import React from 'react';
import './Loader.css';

const Loader = () => (
    <div className="loader"></div>
);

export default Loader;